module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "had-wap-service"
  }, [_c('h1', {
    staticClass: "title f18"
  }, [_vm._v("海渡职校客户端最终用户许可协议")]), _vm._v(" "), _c('div', {
    staticClass: "stage f13"
  }, [_vm._v("\n    务必仔细阅读和理解本海渡职校客户端最终用户许可协议（《协议》）中规定的所有权利和限制。在安装时，您需要仔细阅读并决定接受或不接受本《协议》的条款。除非或直至您接受本《协议》的条款，否则本软件不得安装在您的计算机上。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "stage f13"
  }, [_vm._v("\n    本《协议》是您与海渡职校之间的法律协议。本软件包括随附的计算机软件，并可能包括相关文档印刷材料。您一旦安装本“软件”，即表示您同意接受本《协议》各项条款的约束。如您不同意本《协议》中的条款，您则不可以安装或使用本“软件”。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "stage f13"
  }, [_vm._v("\n    本“软件”受著作权法及国际著作权条约和其它知识产权法和条约的保护。本“软件”权利只许可使用，而不出售。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "stage f13",
    staticStyle: {
      "text-indent": "0",
      "margin-top": "0.467rem"
    }
  }, [_vm._v("\n    一．海渡职校将本软件在中国大陆地区（除香港、澳门、台湾外的中国境内）的非专有的使用权授予您。 您可以：\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "inner"
  }, [_c('li', {
    staticClass: "f13"
  }, [_vm._v("在一台计算机、工作站、终端机、手持式计算机或其它数字电子仪器（“计算机”）上安装、使用、显示、运行（“运行”）本“软件” 的一份副本。")]), _vm._v(" "), _c('li', {
    staticClass: "f13"
  }, [_vm._v("为了防止复制品损坏而制作备份复制品。这些备份复制品不得通过任何方式提供给他人使用，并在您丧失该合法复制品的所有权时，负责将备份复制品销毁。")]), _vm._v(" "), _c('li', {
    staticClass: "f13"
  }, [_vm._v("为了把该软件用于实际的计算机应用环境或者改进其功能、性能而进行必要的修改；但是，除合同另有约定外，未经海渡职校许可，不得向任何第三方提供修改后的软件")])]), _vm._v(" "), _c('div', {
    staticClass: "stage f13",
    staticStyle: {
      "text-indent": "0",
      "margin-top": "0.467rem"
    }
  }, [_vm._v("\n    二．您保证：\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "inner"
  }, [_c('li', {
    staticClass: "f13"
  }, [_vm._v("\n      不在本协议规定的条款之外，使用、复制、修改、租赁或转让本软件或其中的任一部份。\n    ")]), _vm._v(" "), _c('li', {
    staticClass: "f13"
  }, [_vm._v("\n      只在一台计算机上使用本软件；一份“软件”许可不得在不同的计算机上共同或同时使用。\n    ")]), _vm._v(" "), _c('li', {
    staticClass: "f13"
  }, [_vm._v("\n      只在以下之一前提下，将本系统用于多用户环境或网络系统上：\n      "), _c('ul', {
    staticStyle: {
      "list-style": "none"
    }
  }, [_c('li', {
    staticClass: "f13"
  }, [_vm._v("\n          本“软件”明文许可用于多用户环境或网络系统上；\n        ")]), _vm._v(" "), _c('li', {
    staticClass: "f13"
  }, [_vm._v("\n          使用本“软件”的每一节点及终端都已购买使用许可。\n        ")])])]), _vm._v(" "), _c('li', {
    staticClass: "f13"
  }, [_vm._v("\n      不得对本“软件”进行反向工程、反向编译或反汇编。\n    ")]), _vm._v(" "), _c('li', {
    staticClass: "f13"
  }, [_vm._v("\n      不出租、租赁或出借本“软件”产品。\n    ")]), _vm._v(" "), _c('li', {
    staticClass: "f13"
  }, [_vm._v(" 不出租、租赁或出借本“软件”产品。")])]), _vm._v(" "), _c('div', {
    staticClass: "stage f13",
    staticStyle: {
      "text-indent": "0",
      "margin-top": "0.467rem"
    }
  }, [_vm._v("\n    三. 版权声明:\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "inner"
  }, [_c('p', {
    staticClass: "f13"
  }, [_vm._v("\n        1、本“软件”所有内容，凡注明\"哈工海渡版权所有\"的或与合作伙伴共同发布的任何作品，版权均属哈工海渡所有，任何超越合理使用范畴、并未经哈工海渡书面许可的使用行为，哈工海渡均保留追究法律责任的权利。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "f13"
  }, [_vm._v("\n        2、被许可人使用本“软件”的相关内容时，必须是以提供公共免费信息为使用目的的合理、善意使用，不得对本“软件”内容进行曲解、修改，同时必须保留本“软件”注明的版权信息、logo等，并注明转自“海渡职校APP”。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "f13"
  }, [_vm._v("\n        3、除注明\"哈工海渡版权所有\"的内容外，本“软件”以下内容亦不可任意转载使用：\n        "), _c('ol', {
    staticStyle: {
      "list-style": "none"
    }
  }, [_c('li', [_vm._v("\n            （1）本“软件”所指向的非本“软件”内容的相关链接内容；\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n            （2）已作出不得转载使用或未经许可不得转载使用声明的内容；\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n          （3）未由本“软件”署名或本“软件”引用、转载的他人作品等非本“软件”版权内容；\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n          （4）本“软件”中特有的图形、标志、页面风格、编排方式、程序等；\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n          （5）本“软件”中必须具有特别授权或具有注册用户资格方可知晓的内容；\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n          （6）其他法律不允许或本“软件”认为不适合转载使用的内容。\n          ")])])]), _vm._v(" "), _c('p', {
    staticClass: "f13"
  }, [_vm._v("\n        4、引用、转载本“软件”内容不得进行如下活动：\n        "), _c('ol', {
    staticStyle: {
      "list-style": "none"
    }
  }, [_c('li', [_vm._v("\n            （1）损害哈工海渡或他人利益；\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n          （2）任何违法行为；\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n          （3）任何可能破坏公秩良俗的行为；\n          ")]), _vm._v(" "), _c('li', [_vm._v("\n          （4）擅自同意他人继续引用、转载本“软件”内容；\n          ")])])]), _vm._v(" "), _c('p', {
    staticClass: "f13"
  }, [_vm._v("\n       5、对于不当引用或转载本“软件”内容而引起的任何纠纷或损失，哈工海渡不承担责任。\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "f13"
  }, [_vm._v("\n       6、取得授权许可请联系：\n      "), _c('a', {
    staticClass: "f13",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("0512-65001916(分机8049）")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "f13"
  }, [_vm._v("客服电话：")]), _vm._v(" "), _c('a', {
    staticClass: "f13",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("0512-65001916")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('label', {
    staticClass: "f13"
  }, [_vm._v("E-mail：")]), _vm._v(" "), _c('a', {
    staticClass: "f13",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("edubot@hitrobotgroup.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74f65242","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Service.vue
// module id = 327
// module chunks = 1